// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__0fvfb {
  width: 100%;
}

.styles_paper__u1eWB {
  background: #fff;
  border-radius: 5px;
  position: relative;
  width: 100%;
}

.styles_containerTable__\\+LPyE {
  margin-top: 1rem;
  overflow-x: auto;
  overflow-y: auto;
  width: 100%;
}

.styles_noData__Mzxbs {
  align-items: center;
  color: #18316e;
  display: flex;
  gap: 1rem;
  margin: 0 0 2rem 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/TableCardResumo/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB","sourcesContent":[".container {\n  width: 100%;\n}\n\n.paper {\n  background: #fff;\n  border-radius: 5px;\n  position: relative;\n  width: 100%;\n}\n\n.containerTable {\n  margin-top: 1rem;\n  overflow-x: auto;\n  overflow-y: auto;\n  width: 100%;\n}\n\n.noData {\n  align-items: center;\n  color: #18316e;\n  display: flex;\n  gap: 1rem;\n  margin: 0 0 2rem 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__0fvfb`,
	"paper": `styles_paper__u1eWB`,
	"containerTable": `styles_containerTable__+LPyE`,
	"noData": `styles_noData__Mzxbs`
};
export default ___CSS_LOADER_EXPORT___;
